import React from 'react';
import PropTypes from 'prop-types';
import { getApiErrorLogEntry } from '@/util/helper';
import { getErrMessage } from '@/util/helper/errorHandler';
import { useRouter } from '@/util/hook/custom';
import useEffect from '@/util/hook/useEffect';
import useSelector from '@/util/hook/useSelector';
import { selectLiffId, selectLogSessionToken } from '@/util/redux/auth';
import { entryAPI } from '@/api/log';
import errorImg from '@/asset/image/error.svg';
import { S } from './style';
import ConfigHeader from '../../helper/ConfigHeader';
/* Send logs to record the API error event */
const useLogError = ({ _id, errCode, errMessage, logSessionToken, }) => {
    useEffect(() => {
        const { level, msg, payload } = getApiErrorLogEntry(errMessage, errCode);
        if (logSessionToken) {
            entryAPI.Post({
                _id,
                sessionToken: logSessionToken,
                log: {
                    level,
                    msg,
                    payload,
                },
            });
        }
    }, []);
};
export default function ApiError({ customerServiceUrl, }) {
    const { useParams } = useRouter();
    const { errCode = 'undefined' } = useParams();
    const _id = useSelector(selectLiffId);
    const logSessionToken = useSelector(selectLogSessionToken);
    const errMessage = getErrMessage(errCode);
    useLogError({ _id, errCode, errMessage, logSessionToken });
    return (<S.Wrapper>
      <ConfigHeader />
      <S.Content>
        <S.Img src={errorImg} alt='error'/>
        <S.Title>
          糟糕！
          <br />
          系統似乎出了點問題
        </S.Title>
        <S.Text>您可以將此畫面截圖傳送至Home心粉專，我們會盡速協助您。</S.Text>
        <S.Message>＊{errMessage}</S.Message>
      </S.Content>
      <S.Link href={customerServiceUrl}>聯絡客服</S.Link>
    </S.Wrapper>);
}
ApiError.propTypes = {
    customerServiceUrl: PropTypes.string.isRequired,
};
